import {IBetWayWinData, IFinalEvaluatedArea, IMentalGameData} from "../server/MentalData";
import {Mental} from "../Mental";
import {TimelineLite} from "gsap";
import {MentalNormalSymbol} from "../reel/symbols/MentalNormalSymbol";
import {MentalSymbolStates} from "../reel/MentalSymbol";
import {MentalGameMode} from "../server/MentalGameMode";

export class NoWinPresentation {
    public static checkForNoWinSyms(reelId: number): void {
        this.tryDimmingScatter(reelId);
        if (this.isWinRound()) {
            if (this.isFirstS2Triggered()) {
                //S2 on reel 1;
            } else if (this.isE1Triggered()) {
                //E on reel 1;
            } else if (this.checkForLandingDeadSymInFirstThreeReels()) {
                //Dead present, check for M syms
                this.tryDimmingNoWinSymsWithDead(reelId);
            } else {
                //go for dimming no_win syms
                if (reelId === 2) {
                    this.dimDownReels();
                } else if (reelId > 2) {
                    this.tryDimmingNoWinSyms(reelId);
                }
            }
        }
    }

    public static dimAtInitialWin(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        tl.add(() => {
            this.dimDownReels(true);
        }, 0);

        return tl;
    }

    public static isWinRound(): boolean {
        return Mental.model.gameData.totalBetWayWinnings > 0;
    }

    public static isFirstS2Triggered(): boolean {
        return (Mental.model.gameData.firstS2FeatureTriggered.length > 0);
    }

    public static isE1Triggered(): boolean {
        return (Mental.model.gameData.specialReelsOpen[0]);
    }

    public static getWinNoWinSymsData(): boolean[][][] {
        const gameData: IMentalGameData = Mental.model.gameData,
            betWayWinData: IBetWayWinData[] = JSON.parse(JSON.stringify(gameData.betWayWins)); // #263, don't do shallow copy.

        let symsWinNoWinData: boolean[][][] = [];

        for (let i: number = 0; i < betWayWinData.length; i++) {
            const winSym: IBetWayWinData = betWayWinData[i];

            if (i === 0) {
                symsWinNoWinData = winSym.reelWinPositions;
            } else {
                for (let j: number = 0; j < winSym.reelWinPositions.length; j++) {
                    const symData: boolean[][] = winSym.reelWinPositions[j];
                    for (let k: number = 0; k < symData.length; k++) {
                        for (let l: number = 0; l < symData[k].length; l++) {
                            if (!(symsWinNoWinData[j][k][l]) && symData[k][l]) {
                                symsWinNoWinData[j][k][l] = true;
                            }
                        }
                    }
                }
            }
        }
        return symsWinNoWinData;
    }

    public static getWinNoWinSymStatus(reelId: number, symId: number, partId: number): boolean {
        const winNoWinSymsData: boolean[][][] = this.getWinNoWinSymsData();
        let flag: boolean = false;

        if (winNoWinSymsData.length) {
            flag = winNoWinSymsData[reelId][symId][partId];
        }
        return flag;
    }

    public static tryDimmingScatter(reelId: number, fromSplit: boolean = false): void {
        const gameData: IMentalGameData = Mental.model.gameData,
            scatterCount: number = this.getScatterCount();

        if (scatterCount > 0 && scatterCount < 3) {
            if (gameData.nearWinReels.includes(true)) {
                if (reelId === 4) {
                    const reelsToDim: number[] = [0, 2];
                    for (let reel:number = 0; reel < reelsToDim.length; reel++) {
                        this.dimDownScatterSym(reelsToDim[reel]);
                    }
                }
            } else {
                if (reelId === 2 || reelId === 4 || (fromSplit && reelId === 0)) {
                    if (reelId === 2 && gameData.scatterPositions[reelId] === -1) {
                        reelId = 0;
                    }

                    this.dimDownScatterSym(reelId);
                }
            }
        }
    }

    private static dimDownScatterSym(reelId: number): void {
        const gameData: IMentalGameData = Mental.model.gameData,
            symId: number = gameData.scatterPositions[reelId],
            scatterSym: MentalNormalSymbol = <MentalNormalSymbol>Mental.reelArea.getReel(reelId).model.getReelSymbolAt(symId).positionable;

        if (scatterSym._splitSymbols.length > 0) {
            for (let splitSym: number = 0; splitSym < scatterSym._splitSymbols.length; splitSym++) {
                scatterSym._splitSymbols[splitSym].setState(MentalSymbolStates.NO_WIN);
            }
        } else {
            scatterSym.setState(MentalSymbolStates.NO_WIN);
        }
    }

    private static dimDownReels(atInitialWin: boolean = false): void {
        for (let i: number = 0; i < 5; i++) {
            this.tryDimmingNoWinSyms(i, atInitialWin);
        }
    }

    private static tryDimmingNoWinSymsWithDead(reelId: number): void {
        const reelsToCheck: number[] = [0, 1, 2],
            gameData: IMentalGameData = Mental.model.gameData,
            reelEvaluatedArea: string[][] = gameData.evaluatedArea,
            finalEvaluatedArea: IFinalEvaluatedArea[][][] = gameData.finalEvaluatedArea;

        if (reelId === 2) {
            for (let i: number = 0; i <= reelId; i++) {
                if (reelEvaluatedArea[i].includes("D")) {
                    reelsToCheck.splice(reelsToCheck.indexOf(i), 1);
                }
            }

            if (reelsToCheck.length === 1) {
                //because on reel 0 & 2, D sym is present
                const isMidOnReel_1: boolean = this.checkReelForMidSym(finalEvaluatedArea[1]);

                if (!isMidOnReel_1) {
                    this.dimDownReels();
                }
            } else {
                if (reelsToCheck.includes(2)) { //checking for D sym on reel 2
                    //confirmed D not present on reel 2
                    const isMidOnReel_2: boolean = this.checkReelForMidSym(finalEvaluatedArea[2]); //because on reel 0 & 2, D sym is present

                    if (isMidOnReel_2) { // in case reel 2 has no mid sym, isMidOnReel will be false
                        // reel 0 has D and reel 2 has mid, so checking for reel 1 for mid sym
                        const isMidOnReel_1: boolean = this.checkReelForMidSym(finalEvaluatedArea[1]);
                        if (!isMidOnReel_1) {
                            this.dimDownReels();
                        }
                    } else {
                        //no mid sym on reel 2, it's no win;
                        this.dimDownReels();
                    }
                } else {
                    //reel 2 has D sym;
                    const isMidOnReel_1: boolean = this.checkReelForMidSym(finalEvaluatedArea[1]);
                    if (!isMidOnReel_1) {
                        this.dimDownReels();
                    } else {
                        //check for reel 0 for mid sym;
                        const isMidOnReel_0: boolean = this.checkReelForMidSym(finalEvaluatedArea[0]);
                        if (!isMidOnReel_0) {
                            this.dimDownReels();
                        }
                    }
                }
            }
        }
    }

    private static checkReelForMidSym(finalEvaluatedAreaForReel: IFinalEvaluatedArea[][]): boolean {
        let midSymExists: boolean = false;

        for (let i: number = 0; i < finalEvaluatedAreaForReel.length; i++) {
            for (let j:number = 0; j < finalEvaluatedAreaForReel[i].length; j++) {
                if (finalEvaluatedAreaForReel[i][j].name.indexOf("M") > -1) {
                    midSymExists = true;
                    break;
                }
            }
        }

        return midSymExists;
    }

    private static tryDimmingNoWinSyms(reelId: number, atInitialWin: boolean = false): void {
        const symbolsWinNoWinData: boolean[][][] = NoWinPresentation.getWinNoWinSymsData(),
            reelSymData: boolean[][] = symbolsWinNoWinData[reelId];

        if (symbolsWinNoWinData.length > 0 && reelSymData) {
            const symbols: MentalNormalSymbol[] = (Mental.reelArea.getReel(reelId).getAllVisibleStopSymbolsWithEnhancerSymbols()) as MentalNormalSymbol[];
            for (let symId: number = 0; symId < reelSymData.length; symId++) {
                const noWinSym: MentalNormalSymbol = symbols[symId],
                    stateToApply: MentalSymbolStates = atInitialWin ? MentalSymbolStates.NO_WIN_DARK : MentalSymbolStates.NO_WIN;

                // #245, #211
                //todo remove fail safe check for xWays expand once fixed
                //noWinSym._splitSymbols.length < reelSymData[symId].length

                if (!atInitialWin && noWinSym.symbolName === "S" && Mental.scatterAnticipation.checkForNearWin()) {
                    //do nothing on scatter 1
                } else {
                    if (noWinSym.symbolName === "S" && Mental.model.gameData.nextMode !== MentalGameMode.NORMAL) {
                        //do nothing on scatter 1
                    } else {
                        for (let partId: number = 0; partId < reelSymData[symId].length; partId++) {
                            if (!(reelSymData[symId][partId]) && (noWinSym && noWinSym._splitSymbols)) { // added safe check, Jonas reported crash
                                if (noWinSym._splitSymbols.length) {
                                    noWinSym._splitSymbols[partId] && noWinSym._splitSymbols[partId].setState(stateToApply);
                                } else {
                                    noWinSym.setState(stateToApply);
                                }
                            } else {
                                // #95 resetting tint for win & no win cases
                                if (atInitialWin && reelSymData[symId][partId]) {
                                    if (noWinSym._splitSymbols.length) {
                                        // #259 checking for currentTextureState also to be safe
                                        if (noWinSym._splitSymbols[partId] && noWinSym._splitSymbols[partId].currentTextureState) {
                                            noWinSym._splitSymbols[partId].currentTextureState.tint = 0xffffff;
                                        }
                                    } else {
                                        // #259 checking for currentTextureState also to be safe for xNudge
                                        if (noWinSym.currentTextureState) {
                                            noWinSym.currentTextureState.tint = 0xffffff;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    private static checkForLandingDeadSymInFirstThreeReels(): boolean {
        let flag: boolean = false;

        for (let reelId: number = 0; reelId < 3; reelId++) {
            if (Mental.model.gameData.evaluatedArea[reelId].includes("D")) {
                flag = true;
            }
        }

        return flag;
    }

    private static getScatterCount(): number {
        const count: number[] = Mental.model.gameData.scatterPositions;

        return count.filter(function (x) {
            return x !== -1;
        }).length;
    }
}